import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute = ({
  children,
  vqHost,
}: {
  children: ReactElement;
  vqHost: string;
}) => {
  const isDev = process.env.NODE_ENV === 'development';
  const location = useLocation();

  const isAuth = isDev || (window as any)?.veeqoContext?.vqHost === vqHost;

  if (!isAuth) return <Navigate to="/vq/sc/signin" state={{ from: location }} replace />;

  return children;
};
